// src/components/Header.jsx
import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Wordmark from "./Wordmark";
import { whatsappLink } from "../data/site";
import "./Header.css";

const NAV = [
  { to: "/", label: "Início", end: true },
  { to: "/servicos", label: "Serviços" },
  { to: "/portfolio", label: "Portfólio" },
  { to: "/sobre", label: "Sobre" },
  { to: "/contato", label: "Contato" },
];

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function onScroll() {
      setScrolled(window.scrollY > 24);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Fecha o menu ao voltar para desktop (redimensionamento)
  useEffect(() => {
    function onResize() {
      if (window.innerWidth > 768) setOpen(false);
    }
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const close = () => setOpen(false);

  return (
    <header className={`header ${scrolled ? "header--scrolled" : ""} ${open ? "header--open" : ""}`}>
      <div className="telemetry-bar">
        <span className="telemetry-rec">
          <span className="rec-dot" /> REC
        </span>
        <span>RMR · RECIFE/PE</span>
      </div>
      <div className="header-inner">
        <Link to="/" className="logo" onClick={close}>
          <Wordmark />
        </Link>

        <nav className="nav" aria-label="Principal">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className="nav-link">
              {item.label}
            </NavLink>
          ))}
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary btn-sm nav-cta"
          >
            WhatsApp
          </a>
        </nav>

        <button
          type="button"
          className="nav-toggle"
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          aria-expanded={open}
          aria-controls="menu-mobile"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="nav-toggle-bar" />
          <span className="nav-toggle-bar" />
          <span className="nav-toggle-bar" />
        </button>
      </div>

      <div id="menu-mobile" className="nav-mobile" hidden={!open}>
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className="nav-mobile-link"
            onClick={close}
          >
            {item.label}
          </NavLink>
        ))}
        <a
          href={whatsappLink()}
          target="_blank"
          rel="noreferrer"
          className="btn btn-primary nav-mobile-cta"
          onClick={close}
        >
          WhatsApp
        </a>
      </div>
    </header>
  );
}

export default Header;
